var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _g2, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g3, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageGoldCoins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 96,
    viewBox: "0 0 216 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3033_5134)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.2753 76.8922V63.0125H214.657V76.8922C214.657 76.9767 214.657 77.0678 214.657 77.1589C214.677 90.2516 152.999 90.6418 145.966 90.6418C138.933 90.6418 77.2551 90.2516 77.2551 77.1589C77.2551 77.0678 77.2686 76.9832 77.2753 76.8922Z",
    fill: "#FFBB45"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2551 77.1588C78.0948 89.9914 138.98 90.6418 145.966 90.6418C152.952 90.6418 213.81 89.8483 214.657 77.0222C214.657 77.0222 214.657 78.284 214.657 78.3751C214.657 91.4678 152.979 91.845 145.946 91.845C138.913 91.845 77.235 91.4678 77.235 78.3751L77.2551 77.1588Z",
    fill: "#E3931B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3033_5134",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 77,
    y: 63,
    width: 138,
    height: 28
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2753 76.8922V63.0125H214.657V76.8922C214.657 76.9767 214.657 77.0678 214.657 77.1589C214.677 90.2516 152.999 90.6418 145.966 90.6418C138.933 90.6418 77.2551 90.2516 77.2551 77.1589C77.2551 77.0678 77.2686 76.9832 77.2753 76.8922Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3033_5134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216 64.1182H213.871V91.7866H216V64.1182Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.09 64.1182H208.96V91.7866H211.09V64.1182Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.179 64.1182H204.05V91.7866H206.179V64.1182Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.269 64.1182H199.14V91.7866H201.269V64.1182Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.359 64.1182H194.229V91.7866H196.359V64.1182Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.448 64.1182H189.319V91.7866H191.448V64.1182Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.538 64.1182H184.409V91.7866H186.538V64.1182Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.628 64.1182H179.498V91.7866H181.628V64.1182Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.717 64.1182H174.588V91.7866H176.717V64.1182Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.807 64.1182H169.678V91.7866H171.807V64.1182Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.897 64.1182H164.767V91.7866H166.897V64.1182Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.987 64.1182H159.857V91.7866H161.987V64.1182Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.076 64.1182H154.947V91.7866H157.076V64.1182Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.166 64.1182H150.036V91.7866H152.166V64.1182Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.262 64.1182H145.133V91.7866H147.262V64.1182Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.352 64.1182H140.223V91.7866H142.352V64.1182Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.442 64.1182H135.312V91.7866H137.442V64.1182Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.531 64.1182H130.402V91.7866H132.531V64.1182Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.621 64.1182H125.492V91.7866H127.621V64.1182Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.711 64.1182H120.581V91.7866H122.711V64.1182Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.8 64.1182H115.671V91.7866H117.8V64.1182Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.89 64.1182H110.761V91.7866H112.89V64.1182Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.98 64.1182H105.85V91.7866H107.98V64.1182Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.069 64.1182H100.94V91.7866H103.069V64.1182Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1592 64.1182H96.0298V91.7866H98.1592V64.1182Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2489 64.1182H91.1195V91.7866H93.2489V64.1182Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3386 64.1182H86.2092V91.7866H88.3386V64.1182Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4282 64.1182H81.2988V91.7866H83.4282V64.1182Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.5179 64.1182H76.3885V91.7866H78.5179V64.1182Z",
    fill: "#E3931B"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M145.966 76.2938C152.999 76.2938 214.677 75.9555 214.677 64.3457C214.677 52.7359 152.999 52.3977 145.966 52.3977C138.933 52.3977 77.2551 52.7294 77.2551 64.3457C77.2551 75.962 138.933 76.2938 145.966 76.2938Z",
    fill: "#E3931B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M145.966 74.993C152.999 74.993 214.677 74.6548 214.677 63.0449C214.677 51.4351 152.999 51.0969 145.966 51.0969C138.933 51.0969 77.2551 51.4286 77.2551 63.0449C77.2551 74.6613 138.933 74.993 145.966 74.993Z",
    fill: "#FFE669"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M145.966 71.0904C179.358 71.0904 206.428 67.4883 206.428 63.0448C206.428 58.6014 179.358 54.9993 145.966 54.9993C112.574 54.9993 85.5039 58.6014 85.5039 63.0448C85.5039 67.4883 112.574 71.0904 145.966 71.0904Z",
    fill: "#FFBB45"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M145.966 71.0904C179.358 71.0904 206.428 67.4883 206.428 63.0448C206.428 58.6014 179.358 54.9993 145.966 54.9993C112.574 54.9993 85.5039 58.6014 85.5039 63.0448C85.5039 67.4883 112.574 71.0904 145.966 71.0904Z",
    fill: "#FFBB45"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M145.966 56.3653C114.307 56.3653 88.3386 59.6174 85.7256 63.728C85.593 63.5342 85.5165 63.3096 85.5039 63.0775C85.5039 58.6353 112.574 55.032 145.959 55.032C179.344 55.032 206.414 58.6353 206.414 63.0775C206.404 63.309 206.33 63.5336 206.2 63.728C203.6 59.6044 177.624 56.3653 145.966 56.3653Z",
    fill: "#D98A14"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M140.344 69.0546V68.2806C134.365 68.2026 129.341 67.975 125.398 67.6302C121.005 67.2205 118.781 66.6937 118.781 66.0693C118.781 65.1847 124.719 64.5343 136.441 64.118L140.344 63.9879V61.4318C135.259 61.5229 132.78 61.7245 132.78 62.0367V62.1538H120.803V62.0237C120.803 61.5099 123.107 61.1131 127.655 60.8335C131.121 60.6253 135.386 60.5083 140.344 60.4822V59.7083H149.929V60.5018C164.519 60.6904 171.915 61.3993 171.915 62.6156C171.915 63.1619 169.98 63.6172 166.178 63.9749C163.31 64.2416 158.789 64.4953 152.663 64.7164L149.929 64.814V67.3441C153.993 67.292 156.962 67.2075 158.782 67.0904C161.416 66.9278 162.692 66.6741 162.692 66.3099V66.1863H174.723V66.3099C174.723 66.9603 171.928 67.4806 166.427 67.8319C162.087 68.105 156.539 68.2611 149.929 68.2872V69.0546H140.344ZM140.344 65.1522C137.334 65.2628 135.104 65.3733 133.7 65.4839C131.47 65.666 130.389 65.8936 130.389 66.1928C130.389 66.492 131.349 66.7782 133.257 66.9798C134.997 67.1619 137.381 67.2725 140.344 67.3245V65.1522ZM149.929 63.6627C153.106 63.5392 155.424 63.4221 156.834 63.3115C159.172 63.1229 160.301 62.8888 160.301 62.5961C160.301 61.9457 156.942 61.5684 149.929 61.4253V63.6627Z",
    fill: "#D98A14"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M140.344 67.4417V66.6677C134.365 66.5897 129.341 66.362 125.398 66.0173C121.005 65.601 118.781 65.0807 118.781 64.4563C118.781 63.5718 124.719 62.9214 136.441 62.5051L140.344 62.375V59.8124C135.259 59.91 132.78 60.1051 132.78 60.4238V60.5409H120.803V60.4238C120.803 59.91 123.107 59.5067 127.655 59.2335C131.121 59.0254 135.386 58.9083 140.344 58.8823V58.1213H149.929V58.9148C164.519 59.1035 171.915 59.8124 171.915 61.0222C171.915 61.575 169.98 62.0303 166.178 62.388C163.31 62.6547 158.789 62.9018 152.663 63.1295L149.929 63.2271V65.7506C153.993 65.6986 156.962 65.6206 158.782 65.5035C161.416 65.3409 162.692 65.0872 162.692 64.7165V64.5994H174.723V64.7165C174.723 65.3669 171.928 65.8937 166.427 66.245C162.087 66.5181 156.539 66.6742 149.929 66.6937V67.4677L140.344 67.4417ZM140.344 63.5393C137.334 63.6498 135.104 63.7604 133.7 63.871C131.47 64.0466 130.389 64.2807 130.389 64.5734C130.389 64.8661 131.349 65.1653 133.257 65.3669C134.997 65.549 137.381 65.6596 140.344 65.7051V63.5393ZM149.929 62.0238C153.106 61.9002 155.424 61.7831 156.834 61.6661C159.172 61.484 160.301 61.2498 160.301 60.9571C160.301 60.3067 156.942 59.923 149.929 59.7864V62.0238Z",
    fill: "#FFE669"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M3.95653 80.5994L0.5979 67.1099L134.157 35.8447L137.516 49.3342C137.516 49.4188 137.576 49.5033 137.603 49.5944C140.78 62.3164 80.9161 76.723 74.0847 78.323C67.2532 79.923 7.20096 93.5881 4.00355 80.8856C3.9834 80.775 3.97668 80.684 3.95653 80.5994Z",
    fill: "#FFBB45"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00354 80.8857C7.93985 93.1654 67.2733 79.9361 74.0645 78.3491C80.8556 76.7621 139.82 62.1084 137.516 49.4514C137.516 49.4514 137.845 50.6742 137.865 50.7522C141.049 63.4873 81.1915 77.8938 74.3735 79.4938C67.5555 81.0938 7.47636 94.7589 4.2991 82.0304L4.00354 80.8857Z",
    fill: "#E3931B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3033_5134",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 35,
    width: 138,
    height: 52
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.95653 80.5994L0.5979 67.1099L134.157 35.8447L137.516 49.3342C137.516 49.4188 137.576 49.5033 137.603 49.5944C140.78 62.3164 80.9161 76.723 74.0847 78.323C67.2532 79.923 7.20096 93.5881 4.00355 80.8856C3.9834 80.775 3.97668 80.684 3.95653 80.5994Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3033_5134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.698 36.6186L133.629 37.103L140.343 63.9968L142.413 63.5123L135.698 36.6186Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.924 37.7389L128.855 38.2234L135.569 65.1171L137.639 64.6327L130.924 37.7389Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.157 38.8578L124.088 39.3423L130.802 66.236L132.872 65.7516L126.157 38.8578Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.377 39.9716L119.307 40.4561L126.021 67.3498L128.091 66.8653L121.377 39.9716Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.608 41.0905L114.538 41.575L121.252 68.4687L123.322 67.9842L116.608 41.0905Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.834 42.2108L109.764 42.6953L116.479 69.5891L118.548 69.1046L111.834 42.2108Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.067 43.3231L104.997 43.8076L111.711 70.7014L113.781 70.2169L107.067 43.3231Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.286 44.4435L100.217 44.928L106.931 71.8217L109.001 71.3373L102.286 44.4435Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5174 45.5561L95.4476 46.0405L102.162 72.9343L104.232 72.4498L97.5174 45.5561Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.7502 46.6684L90.6804 47.1528L97.3948 74.0466L99.4646 73.5621L92.7502 46.6684Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9764 47.7887L85.9066 48.2732L92.621 75.167L94.6908 74.6825L87.9764 47.7887Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2023 48.9074L81.1326 49.3918L87.847 76.2856L89.9167 75.8011L83.2023 48.9074Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4285 50.0277L76.3588 50.5122L83.0731 77.406L85.1429 76.9215L78.4285 50.0277Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6597 51.1403L71.59 51.6248L78.3044 78.5185L80.3741 78.034L73.6597 51.1403Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8859 52.2607L66.8162 52.7451L73.5305 79.6389L75.6003 79.1544L68.8859 52.2607Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1119 53.3793L62.0421 53.8638L68.7565 80.7575L70.8262 80.2731L64.1119 53.3793Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3381 54.4933L57.2683 54.9778L63.9827 81.8715L66.0524 81.3871L59.3381 54.4933Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5693 55.6056L52.4995 56.0901L59.2139 82.9838L61.2836 82.4994L54.5693 55.6056Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7955 56.726L47.7257 57.2104L54.4401 84.1042L56.5098 83.6197L49.7955 56.726Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0214 57.8449L42.9517 58.3293L49.666 85.2231L51.7358 84.7386L45.0214 57.8449Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2476 58.9652L38.1779 59.4497L44.8922 86.3435L46.962 85.859L40.2476 58.9652Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4788 60.0775L33.4091 60.562L40.1234 87.4558L42.1932 86.9713L35.4788 60.0775Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6983 61.1979L28.6285 61.6824L35.3429 88.5761L37.4127 88.0917L30.6983 61.1979Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.931 62.3168L23.8612 62.8013L30.5756 89.695L32.6453 89.2106L25.931 62.3168Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1572 63.4306L19.0874 63.915L25.8018 90.8088L27.8715 90.3243L21.1572 63.4306Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3899 64.5495L14.3202 65.0339L21.0346 91.9277L23.1043 91.4432L16.3899 64.5495Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6078 65.6635L9.53809 66.1479L16.2525 93.0417L18.3222 92.5572L11.6078 65.6635Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8405 66.7821L4.77075 67.2666L11.4851 94.1604L13.5549 93.6759L6.8405 66.7821Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.0667 67.9025L-0.00305176 68.387L6.71133 95.2807L8.78108 94.7963L2.0667 67.9025Z",
    fill: "#E3931B"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5835 64.392C107.469 55.7583 136.072 43.5597 134.471 37.1457C132.87 30.7318 101.67 32.5313 64.7846 41.165C27.8991 49.7988 -0.704307 61.9974 0.897023 68.4114C2.49835 74.8253 33.6981 73.0258 70.5835 64.392Z",
    fill: "#E3931B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2644 63.1206C107.15 54.4868 135.753 42.2882 134.152 35.8742C132.551 29.4603 101.351 31.2598 64.4655 39.8936C27.58 48.5273 -1.0234 60.7259 0.577932 67.1399C2.17926 73.5538 33.379 71.7543 70.2644 63.1206Z",
    fill: "#FFE669"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3174 59.3274C101.775 51.7301 127.212 42.0701 126.134 37.751C125.056 33.432 97.8698 36.0895 65.4125 43.6868C32.9552 51.2841 7.51745 60.9441 8.59575 65.2632C9.67406 69.5822 36.8601 66.9247 69.3174 59.3274Z",
    fill: "#FFBB45"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3174 59.3274C101.775 51.7301 127.212 42.0701 126.134 37.751C125.056 33.432 97.8698 36.0895 65.4125 43.6868C32.9552 51.2841 7.51745 60.9441 8.59575 65.2632C9.67406 69.5822 36.8601 66.9247 69.3174 59.3274Z",
    fill: "#FFBB45"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7485 45.022C34.9767 52.2221 10.5192 61.2823 8.98095 65.8807C8.79025 65.7049 8.65711 65.4787 8.59806 65.2302C7.51659 60.9115 32.9548 51.2529 65.4126 43.6562C97.8704 36.0594 125.062 33.4057 126.137 37.7504C126.194 37.9882 126.177 38.2371 126.09 38.4659C122.55 35.0512 96.5403 37.8155 65.7485 45.022Z",
    fill: "#D98A14"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3638 58.6286L63.1758 57.8742C57.3452 59.175 52.4281 60.0856 48.4851 60.6254C44.1122 61.2238 41.8216 61.2238 41.6671 60.6254C41.4522 59.7603 47.0409 57.7831 58.3662 54.7327L62.1346 53.718L61.5099 51.227C56.5861 52.4693 54.2217 53.2237 54.3023 53.5294V53.6465L42.6948 56.3717V56.2546C42.5672 55.7538 44.71 54.8433 49.0628 53.5424C52.3811 52.5473 56.4988 51.4611 61.3151 50.2904L61.1203 49.5294L70.4371 47.344L70.6319 48.118C84.859 44.983 92.2144 43.9879 92.51 45.1652C92.6443 45.6985 90.8777 46.5831 87.2638 47.7668C84.5433 48.6839 80.1838 49.9587 74.3062 51.5652L71.6731 52.2871L72.2911 54.7392C76.2274 53.7636 79.0956 53.0026 80.8354 52.4823C83.3544 51.7278 84.5366 51.1814 84.4426 50.8302V50.7132L96.1306 47.9749V48.092C96.2918 48.7424 93.7057 49.8676 88.4461 51.4611C84.2948 52.7164 78.9411 54.1278 72.5194 55.6563L72.7008 56.4042L63.3638 58.6286ZM62.4167 54.8302C59.5148 55.6237 57.372 56.2351 56.0353 56.6644C53.9127 57.3473 52.9118 57.8156 52.9857 58.1083C53.0596 58.401 54.0672 58.4595 55.9614 58.2189C57.7012 57.9977 60.0455 57.5685 62.9406 56.9181L62.4167 54.8302ZM71.3708 51.201C74.4272 50.3619 76.6506 49.718 77.994 49.2888C80.2174 48.5733 81.2653 48.092 81.1914 47.8058C81.0369 47.1554 77.638 47.5782 70.8267 49.0286L71.3708 51.201Z",
    fill: "#D98A14"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9541 57.0612L62.766 56.3067C56.9355 57.6075 52.0184 58.5181 48.0687 59.0579C43.7025 59.6563 41.4119 59.6563 41.2574 59.0579C41.0425 58.1929 46.6648 56.2091 57.9565 53.1652L61.7249 52.1506L61.1203 49.666C56.1966 50.9213 53.8388 51.6758 53.9127 51.9815V52.0985L42.3053 54.8042V54.6872C42.1844 54.1864 44.3205 53.2758 48.68 51.9685C51.9916 50.9798 56.1093 49.8937 60.9255 48.7164L60.7374 47.9489L70.0543 45.7701L70.2423 46.544C84.4695 43.4091 91.8316 42.4139 92.1272 43.5912C92.2548 44.1245 90.4949 45.0091 86.881 46.1928C84.1538 47.1099 79.801 48.3847 73.9234 49.9912L71.2902 50.7067L71.9015 53.1652C75.8042 52.2676 78.6725 51.4807 80.419 50.9668C82.938 50.2058 84.1202 49.666 84.0329 49.3148V49.1912L95.7209 46.4595V46.5766C95.8821 47.227 93.296 48.3522 88.0364 49.9392C83.8851 51.201 78.5247 52.6059 72.103 54.1408L72.2911 54.8823L62.9541 57.0612ZM62.0003 53.2628C59.0984 54.0498 56.9556 54.6677 55.6256 55.0969C53.503 55.7473 52.5021 56.2482 52.576 56.5343C52.6499 56.8205 53.6575 56.8921 55.5517 56.6514C57.2915 56.4303 59.6358 56.001 62.5309 55.3506L62.0003 53.2628ZM70.9745 49.666C74.0376 48.827 76.261 48.1831 77.6045 47.7473C79.8279 47.0384 80.869 46.5571 80.8019 46.2644C80.6407 45.614 77.2484 46.0367 70.4304 47.4936L70.9745 49.666Z",
    fill: "#FFE669"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M194.994 42.2089L196.641 27.5254L57.4147 13.2939L55.7678 27.9774C55.757 28.0737 55.747 28.1632 55.7362 28.2595C54.1827 42.1104 116.635 48.8978 123.761 49.6263C130.888 50.3547 193.429 56.344 194.983 42.4931C194.993 42.3967 194.99 42.3059 194.994 42.2089Z",
    fill: "#FFBB45"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M195.028 42.4174C192.655 55.9551 130.867 50.3066 123.786 49.5801C116.706 48.8535 55.1156 41.6809 55.7596 27.9658C55.7596 27.9658 55.6099 29.3062 55.5991 29.4029C54.0451 43.3112 116.515 50.1268 123.644 50.8583C130.772 51.5897 193.332 57.6039 194.886 43.6956L195.028 42.4174Z",
    fill: "#E3931B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3033_5134",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 13,
    width: 142,
    height: 39
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M194.947 42.0723L196.641 27.2509L57.5074 13.2937L55.814 28.115C55.8028 28.2123 55.7925 28.3025 55.7814 28.3998C54.1839 42.3807 116.593 49.0488 123.715 49.7632C130.836 50.4776 193.338 56.34 194.935 42.3591C194.946 42.2618 194.943 42.1702 194.947 42.0723Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3033_5134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.0166 14.5257L55.9297 14.3132L52.6625 43.3278L54.7493 43.5403L58.0166 14.5257Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9952 15.0442L60.9083 14.8318L57.6411 43.8463L59.728 44.0588L62.9952 15.0442Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9738 15.5621L65.887 15.3496L62.6197 44.3642L64.7066 44.5766L67.9738 15.5621Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9525 16.0804L70.8656 15.8679L67.5984 44.8825L69.6852 45.0949L72.9525 16.0804Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.9311 16.5987L75.8442 16.3862L72.577 45.4008L74.6639 45.6132L77.9311 16.5987Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9096 17.1165L80.8228 16.9041L77.5555 45.9186L79.6424 46.1311L82.9096 17.1165Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8883 17.6348L85.8014 17.4224L82.5342 46.4369L84.621 46.6494L87.8883 17.6348Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8669 18.1526L90.78 17.9402L87.5128 46.9547L89.5997 47.1672L92.8669 18.1526Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8454 18.6712L95.7585 18.4587L92.4913 47.4733L94.5782 47.6858L97.8454 18.6712Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.816 19.1878L100.729 18.9753L97.4621 47.9899L99.549 48.2024L102.816 19.1878Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.796 19.7068L105.709 19.4944L102.442 48.5089L104.529 48.7214L107.796 19.7068Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.775 20.2252L110.688 20.0127L107.421 49.0273L109.508 49.2397L112.775 20.2252Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.753 20.743L115.666 20.5305L112.399 49.5451L114.486 49.7575L117.753 20.743Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.732 21.2613L120.645 21.0488L117.378 50.0634L119.465 50.2758L122.732 21.2613Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.711 21.7791L125.624 21.5667L122.357 50.5812L124.444 50.7937L127.711 21.7791Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.69 22.2974L130.603 22.085L127.336 51.0995L129.422 51.312L132.69 22.2974Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.667 22.817L135.58 22.6045L132.313 51.6191L134.4 51.8315L137.667 22.817Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.646 23.3348L140.559 23.1223L137.292 52.1369L139.378 52.3493L142.646 23.3348Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.626 23.8509L145.539 23.6384L142.272 52.653L144.359 52.8654L147.626 23.8509Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.604 24.3704L150.517 24.158L147.25 53.1725L149.337 53.385L152.604 24.3704Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.583 24.8882L155.496 24.6758L152.229 53.6903L154.315 53.9028L157.583 24.8882Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.561 25.4066L160.474 25.1941L157.207 54.2087L159.294 54.4211L162.561 25.4066Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.54 25.9244L165.453 25.7119L162.186 54.7265L164.273 54.9389L167.54 25.9244Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.519 26.4427L170.432 26.2302L167.164 55.2448L169.251 55.4572L172.519 26.4427Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.497 26.9612L175.41 26.7488L172.143 55.7633L174.23 55.9758L177.497 26.9612Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.476 27.4791L180.389 27.2666L177.122 56.2812L179.209 56.4936L182.476 27.4791Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.454 27.9974L185.367 27.7849L182.1 56.7995L184.187 57.0119L187.454 27.9974Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.434 28.5152L190.347 28.3027L187.079 57.3173L189.166 57.5298L192.434 28.5152Z",
    fill: "#E3931B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.405 29.033L195.318 28.8206L192.051 57.8351L194.138 58.0476L197.405 29.033Z",
    fill: "#E3931B"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M125.422 34.5934C163.877 38.5274 195.686 36.0524 196.469 29.0652C197.252 22.078 166.713 13.2246 128.258 9.29052C89.8025 5.35644 57.9938 7.83147 57.2108 14.8187C56.4278 21.8058 86.967 30.6593 125.422 34.5934Z",
    fill: "#E3931B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M125.573 33.2298C164.028 37.1639 195.836 34.6889 196.619 27.7017C197.402 20.7145 166.863 11.8611 128.408 7.927C89.953 3.99291 58.1443 6.46795 57.3613 13.4551C56.5783 20.4423 87.1175 29.2958 125.573 33.2298Z",
    fill: "#FFE669"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M126.036 29.1132C159.878 32.5811 187.741 31.5715 188.268 26.8581C188.796 22.1447 161.788 15.5124 127.945 12.0444C94.1026 8.57648 66.2401 9.5861 65.7128 14.2995C65.1854 19.0129 92.1929 25.6452 126.036 29.1132Z",
    fill: "#FFBB45"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M126.036 29.1132C159.878 32.5811 187.741 31.5715 188.268 26.8581C188.796 22.1447 161.788 15.5124 127.945 12.0444C94.1026 8.57648 66.2401 9.5861 65.7128 14.2995C65.1854 19.0129 92.1929 25.6452 126.036 29.1132Z",
    fill: "#FFBB45"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M127.77 13.5327C159.862 16.8346 185.807 23.0079 187.969 27.6522C188.131 27.4494 188.234 27.2051 188.268 26.9472C188.795 22.2151 161.782 15.5534 127.933 12.0708C94.0849 8.58826 66.223 9.60396 65.6957 14.3361C65.6734 14.5958 65.7232 14.8559 65.8394 15.0867C68.9708 10.9659 95.6788 10.2309 127.77 13.5327Z",
    fill: "#D98A14"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M122.265 26.5166L122.356 25.7037C115.658 25.0183 110.056 24.2501 105.691 23.5108C100.158 22.5683 97.3933 21.7419 97.472 21.0392L97.4867 20.9083L109.671 22.1552L109.657 22.2861C109.614 22.6719 110.884 23.0736 113.533 23.5188C115.357 23.8309 118.362 24.229 122.468 24.7049L122.768 22.0251L120.009 21.6383C113.854 20.7716 109.283 20.0321 106.408 19.4522C102.591 18.6784 100.691 17.9962 100.756 17.4176C100.899 16.1363 108.475 16.1172 123.28 17.4579L123.374 16.6174L133.088 17.6114L132.994 18.445C138.018 18.959 142.33 19.5536 145.811 20.1328C150.387 20.9006 152.677 21.5321 152.613 22.1039L152.599 22.2279L140.469 20.9866L140.484 20.8557C140.521 20.5251 138.033 20.0545 132.884 19.4301L132.58 22.1442L136.526 22.6874C148.352 24.3156 154.299 25.6209 154.191 26.5853C154.113 27.2742 151.794 27.5734 147.294 27.5518C143.254 27.5287 138.136 27.2488 132.07 26.6908L131.979 27.5106L122.265 26.5166ZM132.185 25.6713C135.199 25.931 137.65 26.0563 139.414 26.0418C141.363 26.0322 142.369 25.8494 142.407 25.505C142.446 25.1605 141.374 24.8348 139.135 24.4107C137.733 24.1487 135.479 23.7996 132.442 23.3705L132.185 25.6713ZM123.171 18.4292C116.081 17.857 112.633 17.9083 112.556 18.5972C112.521 18.9072 113.644 19.2729 115.983 19.7143C117.4 19.9777 119.733 20.3489 122.939 20.8024L123.171 18.4292Z",
    fill: "#D98A14"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M122.451 24.826L122.538 24.0475C115.84 23.3621 110.239 22.5939 105.874 21.8546C100.341 20.9121 97.5766 20.0789 97.6545 19.3831L97.6692 19.2522L109.854 20.4991L109.839 20.6299C109.796 21.0157 111.066 21.4174 113.715 21.8627C115.539 22.1747 118.545 22.5729 122.65 23.0487L122.954 20.3346L120.195 19.9477C114.041 19.081 109.469 18.3415 106.594 17.7617C102.777 16.9878 100.877 16.3057 100.942 15.7271C101.086 14.4389 108.662 14.4267 123.466 15.7674L123.56 14.927L133.274 15.9209L133.178 16.7751C138.202 17.2892 142.514 17.8837 145.995 18.4629C150.571 19.2307 152.861 19.8622 152.797 20.434L152.783 20.558L140.653 19.3167L140.667 19.1927C140.704 18.8621 138.216 18.3915 133.067 17.7671L132.763 20.4812L136.709 21.0244C148.535 22.6525 154.482 23.9578 154.374 24.9222C154.297 25.6111 151.977 25.9103 147.477 25.8887C143.438 25.8656 138.319 25.5857 132.254 25.0277L132.162 25.8475L122.451 24.826ZM132.371 23.9807C135.386 24.2334 137.836 24.3657 139.6 24.3511C141.551 24.3347 142.555 24.1588 142.593 23.8143C142.632 23.4699 141.56 23.1442 139.322 22.7201C137.919 22.4581 135.665 22.109 132.629 21.6799L132.371 23.9807ZM123.357 16.7387C116.268 16.1665 112.819 16.2178 112.742 16.9066C112.707 17.2166 113.83 17.5823 116.17 18.0238C117.586 18.2872 119.921 18.6515 123.126 19.1119L123.357 16.7387Z",
    fill: "#FFE669"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3033_5134"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 216,
    height: 63.8182,
    fill: "white",
    transform: "translate(0 31.4546)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageGoldCoins);
export default __webpack_public_path__ + "static/media/imageGoldCoins.2446583743a76f76ed11449fba10a9e8.svg";
export { ForwardRef as ReactComponent };